<div class="copyright">
  <span class="copyright-text">{{ getRegistrationNo() }}</span>
</div>